import { VStack } from '@bpba/ui-components';
import { UrlsBack } from '../constants/urls';
import useAxios from 'axios-hooks';
import { IFixedTermItem } from '../types/IFixedTermItem';
import { LIST_GENERAL_ERROR } from '../constants/data';
import { useEffect, useState } from 'react';
import { Spinner } from '../components/shared/Spinner';
import { Titulo } from '../components/shared/Titulo';
import { useMenuContext } from '../components/useMenuContext';
import { ErrorMessageContainer } from '../components/shared/ErrorMessageContainer';
import { useErrorMessage } from '../components/shared/useErrorMessage';
import { axiosMessageExtractor } from '../config/axiosMessageExtractor';
import { PlazosFijosList } from './PlazosFijosList';
import { UnconfirmedWarning } from './UnconfirmedWarning';
import { OrderMode, OrderToggleButton } from './OrderToggleButton';
import { useOrderList } from './useOrderList';
import { StyledBox } from '../components/shared/StyledBox';

export const FixedTermsList = () => {
  const { setOption } = useMenuContext();
  const [{ data, loading }, refech] = useAxios<IFixedTermItem[]>(UrlsBack.FixedTerms, { manual: true });
  const [init, setInit] = useState<boolean>(false);
  const [orderMode, setOrderMode] = useState<OrderMode>('estado');

  useEffect(() => {
    setOption(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    refech().catch(setErrorMessage);
    setInit(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [errorMessage, setErrorMessage, showError] = useErrorMessage(axiosMessageExtractor, LIST_GENERAL_ERROR);

  const orderedData = useOrderList(data, orderMode);

  return (
    <VStack>
      <Titulo mb="0px">Tus plazos fijos</Titulo>
      <VStack>
        {loading && <Spinner width={40} my={'48px'} />}

        <StyledBox gap="0px" my="16px" flexDirection={['column', 'row']} justifyContent={'end'}>
          {!loading && <UnconfirmedWarning data={orderedData} />}
          {!loading && !showError && orderedData && <OrderToggleButton value={orderMode} onChange={setOrderMode} />}
        </StyledBox>

        {!loading && init && !showError && <PlazosFijosList data={orderedData} />}

        <ErrorMessageContainer show={showError && !loading} errorMessage={errorMessage} />
      </VStack>
    </VStack>
  );
};
